<template>
  <div v-if="value" v-bsl="value"></div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import moment from 'moment';

import TeacherSvg from '@/assets/images/onboarding/classlist.svg';
import AttendancesSymbolsPng from '@/assets/images/onboarding/attendances.png';
import ArrowRightSvg from '@/assets/images/onboarding/arrowright.svg';

export default {
  name: 'AttendancesDesktop',
  props: {
    value: {
      required: true,
    },
    isEmpty: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapState('students', ['student']),

    teacherImage() {
      return TeacherSvg;
    },

    attendancesSymbolsImage() {
      return AttendancesSymbolsPng;
    },

    arrowRightImage() {
      return ArrowRightSvg;
    },

    onboardingText() {
      return `
        <div class="flex flex-col justify-center items-center">
          <h3 class="text-center">${this.$t('onboarding.attendances_step2.title')}</h3>
          <p class="text-center py-4 px-8">${this.$t('onboarding.attendances_step2.content')}</p>
          <div class="flex justify-center align-center">
            <img src="${this.attendancesSymbolsImage}"/>
          </div>
        </div>`;
    },
  },
  methods: {
    ...mapMutations('layout', ['showClassList', 'hideClassList']),

    closeOnboardingTag() {
    },

    acceptOnboardingTag() {
    },

    addArrow(tour, direction) {
      const currentStepElement = tour.currentStep.el;
      const header = currentStepElement.querySelector('.shepherd-header');
      const progress = document.createElement('img');
      if (direction === 'right') {
        progress.classList.add('stepherd-custom-arrow--right');
        progress.src = `${this.arrowRightImage}`;
      }
      header.insertBefore(
        progress,
        currentStepElement.querySelector('.shepherd-cancel-icon'),
      );
    },

    getDateWithYearlyOffset(years) {
      return moment().add(years, 'y').toDate();
    },

    startOnboarding() {
      this.$nextTick(() => {
        const vm = this;
        const tour = this.$shepherd({
          useModalOverlay: true,
          defaultStepOptions: {
            cancelIcon: {
              enabled: true,
            },
          },
        });

        vm.hideClassList();

        tour.addStep({
          text: vm.onboardingText,
          beforeShowPromise() {
            return new Promise((resolve) => {
              setTimeout(() => {
                window.scrollTo(0, 0);
                resolve();
              }, 500);
            });
          },
          attachTo: {
            element: this.isEmpty ? null : '.attendances__list',
            on: this.isEmpty ? null : 'right-start',
          },
          canClickTarget: false,
          modalOverlayOpeningRadius: 12,
          popperOptions: {
            placement: 'right-start',
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [0, 270],
                },
              },
            ],
          },
          buttons: [
            {
              text: this.$t('onboarding.attendances_step2.btn'),
              action() {
                vm.acceptOnboardingTag();
                vm.showClassList();
                vm.$emit('input', !vm.value);
                return this.cancel();
              },
            },
          ],
          when: {
            show() {
              if (!vm.isEmpty) {
                vm.addArrow(this.tour, 'right');
              }
            },
            cancel() {
              vm.closeOnboardingTag();
              vm.showClassList();
              vm.$emit('input', !vm.value);
            },
          },
        });

        tour.start();

        Event.$on('cancelTour', () => {
          tour.cancel();
        });
      });
    },
  },

  beforeDestroy() {
    Event.$off('cancelTour');
  },

  watch: {
    value(value) {
      if (value) {
        this.startOnboarding();
      }
    },
  },
};
</script>
